/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MailParamsCrefoTemplateData } from '../../models/mail-params-crefo-template-data';
import { ResponseObject } from '../../models/response-object';

export interface SendCrefoMailboxMail$Params {
      body: MailParamsCrefoTemplateData
}

export function sendCrefoMailboxMail(http: HttpClient, rootUrl: string, params: SendCrefoMailboxMail$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseObject>> {
  const rb = new RequestBuilder(rootUrl, sendCrefoMailboxMail.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseObject>;
    })
  );
}

sendCrefoMailboxMail.PATH = '/sendMail/crefo-mailbox';
